import { render } from "./ModalDeleteCaseAlert.vue?vue&type=template&id=76020a0c&scoped=true"
import script from "./ModalDeleteCaseAlert.vue?vue&type=script&lang=js"
export * from "./ModalDeleteCaseAlert.vue?vue&type=script&lang=js"

import "./ModalDeleteCaseAlert.vue?vue&type=style&index=0&id=76020a0c&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76020a0c"]])

export default __exports__